export default {
  button: 'Alerts',
  modal: {
    header: 'Alerts',
    footer: {
      supportCase: {
        description: 'Report this Wonoloer? ',
        link: 'Open Support case'
      },
      actions: {
        done: 'Done'
      }
    },
    identitySection: {
      stats: {
        totalJobsCompleted: 'Total jobs',
        totalJobsForCustomerCompleted: 'Jobs at %customerName%'
      }
    },
    pictureTag: {
      unavailable: 'MATCHING UNAVAILABLE',
      percentMatch: '%similarityScore%% MATCH',
      noPicture: '—'
    },
    photoFeedbackSection: {
      header: 'Do these photos match the Wonoloer’s profile?',
      profile: 'PROFILE',
      imageFallbackText: {
        clockIn: 'Clock In Photo',
        clockOut: 'Clock Out Photo'
      },
      notMatchingPhotoAlert: 'You\'ve indicated that this is not the same Wonoloer as the one in the profile. Please report this Wonoloer by opening a Support case below.'
    },
    markAsUnread: {
      label: 'Mark as unread'
    },
    messages: {
      autoClockOut: {
        title: 'Auto clocked-out',
        message: 'This Wonoloer was auto clocked-out on '
      }
    },
    noAlerts: 'You have no alerts',
  }
};
